import { create } from 'zustand'

// สถานะข้อมูลบริษัทของ customer ที่ login อยู่ — แชร์ระหว่าง OnboardingGate กับหน้า /onboarding
// 'unknown' = ยังไม่ได้เช็ค, 'incomplete' = ต้องกรอก onboarding, 'complete' = กรอกครบแล้ว
type Status = 'unknown' | 'incomplete' | 'complete'

interface OnboardingState {
  customerId: number | null
  status: Status
  set: (customerId: number, status: Status) => void
  reset: () => void
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  customerId: null,
  status: 'unknown',
  set: (customerId, status) => set({ customerId, status }),
  reset: () => set({ customerId: null, status: 'unknown' }),
}))
